import React, { useContext, useEffect, useState } from "react";
import { observer } from "mobx-react";

import { LoginBox } from "./LoginBox";
import InnerLoginView from "./InnerLoginView";
import { GlobalContext } from "../GlobalContext";

import "../login.scss";
import "../marketplace.scss";
import CookieNotification from "./CookieNotification";

const LoginView = observer(() => {
  const { auth } = useContext(GlobalContext);

  const [footer, setFooter] = useState<React.ReactNode>();

  useEffect(() => {
    const envType = process.env.REACT_APP_ENV_TYPE;

    setFooter(
      (!auth.multiOrgs || auth.multiOrgs.length === 0) && (
        <p>
          Don't have an account yet? <a href={`/signup`}>Sign Up</a>
        </p>
      )
    );
  }, [auth.multiOrgs]);

  return (
    <>
      <CookieNotification />
      <LoginBox basicLogin footer={footer}>
        <InnerLoginView />
      </LoginBox>
    </>
  );
});

export default LoginView;
